import { useState, type ReactNode, type FormEvent } from 'react';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

export function ForgotPage(): ReactNode {
  const { forgot } = useAuth();
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (!username.trim()) { setError(t('auth.login.error.usernameRequired')); return; }
    try {
      await forgot(username.trim());
      setSubmitted(true);
    } catch (err) {
      setError((err as Error).message || t('auth.forgot.requestFailed'));
    }
  }

  if (submitted) {
    return (
      <main aria-label="forgot-confirmation">
        <h1>{t('auth.forgot.checkEmail.title')}</h1>
        <p>{t('auth.forgot.checkEmail.body')}</p>
      </main>
    );
  }
  return (
    <main aria-label="forgot">
      <h1>{t('auth.forgot.title')}</h1>
      <form onSubmit={onSubmit} aria-label="forgot-form">
        <label htmlFor="f-username">{t('auth.login.username')}</label>
        <input id="f-username" name="username" value={username} onChange={(e) => setUsername(e.target.value)} />
        {error ? <p role="alert">{error}</p> : null}
        <button type="submit">{t('auth.forgot.sendReset')}</button>
      </form>
    </main>
  );
}
